import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
var upColor = '#ec0000';
var upBorderColor = '#8A0000';
var downColor = '#00da3c';
var downBorderColor = '#008F28';

function calculateMA(dayCount, data) {
  var result = [];

  for (var i = 0, len = data.length; i < len; i++) {
    if (i < dayCount) {
      result.push('-');
      continue;
    }

    var sum = 0;

    for (var j = 0; j < dayCount; j++) {
      sum += data[i - j][1];
    }

    result.push(sum / dayCount);
  }

  return result;
} // 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)


export default {
  name: 'kLineChart',
  props: ['chart'],
  methods: {
    initKLineChart: function initKLineChart(data) {
      // 数据意义：开盘(open)，收盘(close)，最低(lowest)，最高(highest)
      var data0 = this.splitData(data);
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: ['日K', 'MA5', 'MA10', 'MA20', 'MA30']
        },
        grid: {
          left: '10%',
          right: '10%',
          bottom: '15%'
        },
        xAxis: {
          type: 'category',
          data: data0.categoryData,
          scale: true,
          boundaryGap: false,
          axisLine: {
            onZero: false
          },
          splitLine: {
            show: false
          },
          splitNumber: 20,
          min: 'dataMin',
          max: 'dataMax'
        },
        yAxis: {
          scale: true,
          splitArea: {
            show: true
          }
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100
        }, {
          show: true,
          type: 'slider',
          top: '90%',
          start: 0,
          end: 100
        }],
        series: [{
          name: '日K',
          type: 'candlestick',
          data: data0.values,
          itemStyle: {
            color: upColor,
            color0: downColor,
            borderColor: upBorderColor,
            borderColor0: downBorderColor
          },
          markPoint: {
            label: {
              normal: {
                formatter: function formatter(param) {
                  return param != null ? Math.round(param.value) : '';
                }
              }
            },
            data: [{
              name: 'XX标点',
              coord: ['2013/5/31', 2300],
              value: 2300,
              itemStyle: {
                color: 'rgb(41,60,85)'
              }
            }, {
              name: 'highest value',
              type: 'max',
              valueDim: 'highest'
            }, {
              name: 'lowest value',
              type: 'min',
              valueDim: 'lowest'
            }, {
              name: 'average value on close',
              type: 'average',
              valueDim: 'close'
            }],
            tooltip: {
              formatter: function formatter(param) {
                return param.name + '<br>' + (param.data.coord || '');
              }
            }
          },
          markLine: {
            symbol: ['none', 'none'],
            data: [[{
              name: 'from lowest to highest',
              type: 'min',
              valueDim: 'lowest',
              symbol: 'circle',
              symbolSize: 10,
              label: {
                show: false
              },
              emphasis: {
                label: {
                  show: false
                }
              }
            }, {
              type: 'max',
              valueDim: 'highest',
              symbol: 'circle',
              symbolSize: 10,
              label: {
                show: false
              },
              emphasis: {
                label: {
                  show: false
                }
              }
            }], {
              name: 'min line on close',
              type: 'min',
              valueDim: 'close'
            }, {
              name: 'max line on close',
              type: 'max',
              valueDim: 'close'
            }]
          }
        }, {
          name: 'MA5',
          type: 'line',
          data: this.calculateMA(5, data0),
          smooth: true,
          lineStyle: {
            opacity: 0.5
          }
        }, {
          name: 'MA10',
          type: 'line',
          data: this.calculateMA(10, data0),
          smooth: true,
          lineStyle: {
            opacity: 0.5
          }
        }, {
          name: 'MA20',
          type: 'line',
          data: this.calculateMA(20, data0),
          smooth: true,
          lineStyle: {
            opacity: 0.5
          }
        }, {
          name: 'MA30',
          type: 'line',
          data: this.calculateMA(30, data0),
          smooth: true,
          lineStyle: {
            opacity: 0.5
          }
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option, true);

      window.onresize = function () {
        myChart.resize();
      };
    },
    splitData: function splitData(rawData) {
      var categoryData = [];
      var values = [];

      for (var i = 0; i < rawData.length; i++) {
        categoryData.push(rawData[i].splice(0, 1)[0]);
        values.push(rawData[i]);
      }

      return {
        categoryData: categoryData,
        values: values
      };
    },
    calculateMA: function calculateMA(dayCount, data0) {
      var result = [];

      for (var i = 0, len = data0.values.length; i < len; i++) {
        if (i < dayCount) {
          result.push('-');
          continue;
        }

        var sum = 0;

        for (var j = 0; j < dayCount; j++) {
          sum += data0.values[i - j][1];
        }

        result.push(sum / dayCount);
      }

      return result;
    }
  }
};